// eslint-disable-next-line no-unused-vars
import ChatUser from '../entities/ChatUser';

class UserRepository {
    /**
     * @returns {Promise<ChatUser[]>}
     */
    async getUsers() {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {string} uid
     * @returns {Promise<ChatUser>}
     */
    async getUserById(uid) {
        throw new Error('Method not implemented.');
    }

    /**
     * @param {string} email
     * @returns {Promise<ChatUser>}
     */
    async getUserByEmail(email) {
        throw new Error('Method not implemented.');
    }
}

export default UserRepository;
